import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"
import { Row, Col } from 'react-bootstrap';
import blogDetailLink from '../../utils/blogDetailLink'
import "./post.css"


class Post extends React.Component {
  render() {
     const { post } = this.props;

     const random_colors = [
       '4DE3C7',
       'F055E0',
       '8F55EE',
       '1350DC'
     ]

     let colorsArray = [...random_colors]



    function getColor (){

      let random_number =  Math.floor(Math.random() * colorsArray.length)

      let color

      if (colorsArray.length === 1){
        color = colorsArray[0]
        colorsArray = [...random_colors]
      }else{
        color = colorsArray[random_number]
        colorsArray.splice(random_number, 1)
      }

      return color
    }

     return (
      <div className="post mb-3">
            <Row>
               <Col md="5" xs="12" className="post_col_left">
                  <div className="post-img">
                     <Link to={blogDetailLink(post)}>{post.postFields.defaultFields.featuredImage && <img src={post.postFields.defaultFields.featuredImage.sourceUrl} className="img-fluid" alt="post" />}</Link>
                  </div>
               </Col>
               <Col md="7" xs="12" className="post_col_right">
                  <Link to={blogDetailLink(post)}><h3>{post.title}</h3></Link>
                  <p className="post-text">
                     <div dangerouslySetInnerHTML={{__html: post.postFields.defaultFields.excerpt}} />
                  </p>
                  <div className="d-flex flex-wrap">
                     {post.terms.nodes.filter(term => term.nodeType==="Category").map(term => (
                        <Link to={`/${term.slug}`} className={term.ancestors ? `btn-custom me-2 ${term.slug}` : `btn-custom me-2 ${term.slug}`} style={{backgroundColor: '#'+getColor()}}>{term.name}</Link>
                     ))}
                     <ul className="postMeta">
                        {post.author
                        ?
                           <>
                              {post.author.node && <li><Link to={`/contributor/${post.author.node.slug}`}>{post.author.node.firstName} {post.author.node.lastName}</Link></li>}
                           </>
                        :
                           <>
                              {post.postFields.defaultFields.author && <li><Link to="#">{post.postFields.defaultFields.author}</Link></li>}
                           </>
                        }
                        
                        <li>{post.date}</li>
                     </ul>
                  </div>
               </Col>
            </Row>
      </div>
      )
  }
}

export default Post
